import { Weekday } from "@/constants/dates";
import request from "@/utils/request";

export interface ConcurrentTimeEntity {
  entity: {
    [entityId: string]: number;
  };
  // time contains all the concurrent time intervals for a given category
  time: {
    [categoryId: string]: string[];
  };
}

export interface IPromocode {
  promoCodeId: number;
  promoCodeType: number;
  grouping: number;
  flatValue: number;
  percentValue: number;
  maxUsage: number;
  isValueUnlimited: number;
  isUsageUnlimited: number;
  pendingUsage: string;
  pendingValue: string;
  code: string;
  product: number;
  prices: number[];
  connectionType: number;
  ticket: number;
  ticketGroup: number;
  groupId: number;
  maxUsagePerUnit: number;
  useOnePer: number;
  blockConcurrentTime: number;
  // window length (in minutes) used to block concurrent uses around a booked timeslot
  blockConcurrentTimeDuration: number;
  blackList: ConcurrentTimeEntity[];
  isValidAllDays: boolean;
  validDays: Weekday[];
}

/**
 * Check Validity/Availability of a given promocode
 */
export async function checkPromocode(
  promocode: string,
  pricesIds: number[],
  groupId: number,
  posConfigId: number,
  bookingUuid: string,
  pss: {
    categoryId: number;
    timeSlotId: number | null;
  }[]
) {
  const response = await request({
    url: `/group/${groupId}/check-promocode?PosConfigId=${posConfigId}`,
    method: "post",
    data: {
      promoCode: promocode,
      pricesIds: pricesIds,
      group: groupId,
      bookingUuid,
      pss,
    },
  });

  return response.data;
}
